import { useState } from 'react';
import styles from './size-display.module.scss';

const SizeDisplay = ({ sizes }) => {
    const [selected, setSelected] = useState();

    let sizeRender;

    if (sizes) {
        sizeRender = sizes.map((s) => {
            return (
                <div
                    className={`${styles.box} ${selected === s ? styles.active : ''}`}
                    key={s}
                    onClick={() => setSelected(s)}
                >
                    {s}
                </div>
            );
        });
    }

    return <div className={styles.container}>{sizeRender}</div>;
};

export default SizeDisplay;
